import React from 'react';
import { colors } from 'styleguide';

interface Props {
  width?: number;
  color?: string;
}

const Interactive = ({ width = 20, color = colors('white') }: Props) => (
  <svg width={width} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10" cy="10" r="3.5" stroke={color} />
    <path d="M7 10L2 10" stroke={color} />
    <path d="M17 10L13 10" stroke={color} />
    <circle cx="2" cy="10" r="2" fill={color} />
    <circle cx="18" cy="10" r="2" fill={color} />
    <circle cx="10" cy="10" r="2" fill={color} />
  </svg>
);

export default Interactive;
